"use strict";
/**
 *
 * @param {*} value
 * @param {*} options
 * @description we can pass multiple values as array, giving this function the option
 * to pick any one that has a readable value in order of preference from first to last.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getText = void 0;
var getText = function (value, options) {
    if (options === void 0) { options = {}; }
    if (!value)
        return "";
    var toReturn = Array.isArray(value)
        ? extractFirstTruthyValue(value)
        : extractorFn(value);
    return "".concat(toReturn).concat(options.suffix || "");
};
exports.getText = getText;
var extractFirstTruthyValue = function (valueArray) {
    var value;
    for (var i = 0; i < valueArray.length; i++) {
        value = extractorFn(valueArray[i]);
        if (value)
            break;
    }
    return value;
};
var extractorFn = function (value) {
    if (!value)
        return "";
    //check to see if its draftjs format.
    //if not, simply return the value as is without modification
    if (!Array.isArray(value.blocks))
        return value;
    //else
    return value.blocks
        .filter(function (d) { return !!d.text === true; })
        .map(function (d) { return d.text; })
        .join(" ")
        .trim();
};
